import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import AddEmployee from "./AddEmployee";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../Redux";

const EmployeeList = (params) => {
  const dispatch = useDispatch();

  const completeEmployeeList = useSelector(
    (state) => state.settingReducer?.labourEmployeeList?.employees
  );
  const [employeeList, setEmployeeList] = useState(completeEmployeeList);
  useEffect(() => {
    setEmployeeList(completeEmployeeList);
  }, [completeEmployeeList]);
  const userMerchantID = useSelector(
    (state) => state?.authReducer?.user_details?.user?.merchant_id
  );
  const [formType, setFormType] = useState("add");

  const formOpen = useSelector(
    (state) => state?.settingReducer?.labour_employee_form_state
  );

  const setFormOpen = (state) =>
    dispatch(
      actions.setFormState({
        formName: "labour_employee_form_state",
        formState: state,
      })
    );

  useEffect(() => {
    dispatch(actions.getLabourEmployeeList());
    dispatch(actions.getLabourAddEmployeeFormData());
  }, []);
  function getLabourStatus(value) {
    const statusArray = [
      { value: 1, label: "Full Time" },
      { value: 2, label: "Part Time" },
      { value: 3, label: "Contractor" },
    ];
    return statusArray.find((el) => el.value === value)?.label || "";
  }
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        {formOpen === false && (
          <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
            <div className="container px-0">
              <div className="row mx-0">
                <div className="container px-0">
                  <div className="shadowclass">
                    <div className="top-header-sec d-flex justify-content-between">
                      <h4 className="event-alert mb-3 col-md-4">
                        Employee List
                        <div className="clear"></div>
                      </h4>
                      <ul
                        class="nav summary_filter col-md-4"
                        id="pills-tab"
                        role="tablist"
                      >
                        <li class="nav-item" role="presentation">
                          <a
                            class="nav-link active"
                            id="pills-home-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-home"
                            type="button"
                            role="tab"
                            aria-controls="pills-home"
                            aria-selected="true"
                          >
                            Current
                          </a>
                        </li>
                        <li class="nav-item" role="presentation">
                          <a
                            class="nav-link"
                            id="pills-profile-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-profile"
                            type="button"
                            role="tab"
                            aria-controls="pills-profile"
                            aria-selected="false"
                          >
                            Former
                          </a>
                        </li>
                      </ul>
                    </div>

                    <div className="row justify-content-between align-items-center w-100">
                      <div className="col-md-4">
                        <div className="search-box mt-0">
                          <form>
                            <input
                              onChange={(e) => {
                                const filteredArr = completeEmployeeList.filter(
                                  (el) =>
                                    `${el?.employee_name} ${el?.last_name}`.startsWith(
                                      e.target.value
                                    )
                                );
                                console.log(filteredArr, "filteredArr");
                                setEmployeeList(filteredArr);
                              }}
                              type="text"
                              placeholder="Search"
                              name="keyword1"
                            />
                          </form>
                        </div>
                      </div>
                      <div class="col-md-2 align-right px-0">
                        <div class="field text-right">
                          <button
                            onClick={() => {
                              setFormOpen(true);
                              setFormType("add");
                              dispatch(
                                actions.saveEmployeeTaxDocumentInfo(null)
                              );
                              dispatch(actions.saveEmployeeDocumentInfo(null));
                              dispatch(actions.saveEmployeeBankingInfo(null));
                              dispatch(
                                actions.saveEmployeeDependentsInfo(null)
                              );
                            }}
                            class="btn green-btn-revert add-plus addSp mx-0"
                            id="addCount"
                            type="button"
                          >
                            <i class="i-icon"> </i> Add Employee
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="row mx-0 my-4">
                      <div class="tab-content" id="pills-tabContent">
                        {/* current */}
                        <div
                          class="tab-pane fade show active"
                          id="pills-home"
                          role="tabpanel"
                          aria-labelledby="pills-home-tab"
                        >
                          <div className="table-responsive">
                            <table
                              width="100%"
                              cellspacing="0"
                              cellpadding="0"
                              class="checklist-table table850 remove-space inventory_table"
                            >
                              <thead>
                                <tr>
                                  <th class="pic">&nbsp;</th>
                                  <th width="210">Employee</th>
                                  <th>Status</th>
                                  <th>Function</th>
                                  <th>Employing Account</th>
                                  <th>Contact Number</th>
                                  <th>Email</th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {employeeList?.map((el) => (
                                  <tr>
                                    <td class="avtar_pic">
                                      <figure>
                                        <img
                                          src="/img/../employee_images/1642043986.png"
                                          id="preview"
                                          alt=""
                                        />{" "}
                                      </figure>
                                    </td>
                                    <td>
                                      <b>
                                        {el?.employee_name +
                                          " " +
                                          el?.last_name}
                                      </b>{" "}
                                      <br />
                                      {el?.role_title}
                                    </td>
                                    <td>
                                      {" "}
                                      <span class="green_tag">
                                        {" "}
                                        {getLabourStatus(
                                          el?.employment_status_id
                                        )}{" "}
                                      </span>
                                    </td>
                                    <td>{el?.employee_function["name"]}</td>
                                    <td>{el?.merchant?.account_name}</td>
                                    <td>{el?.contact_number_1}</td>
                                    <td>{el?.email}</td>
                                    <td
                                      onClick={() => {
                                        dispatch(
                                          actions.getEditLabourEmployeeData({
                                            id: el?.id,
                                            merchant_id: userMerchantID,
                                          })
                                        );
                                        // setFormOpen(true);
                                        setFormType("edit");
                                      }}
                                    >
                                      <p class="circle_icon">
                                        <i class="iconSprites edit-icon">
                                          {" "}
                                          <div class="tooltip-sm">
                                            {" "}
                                            Edit{" "}
                                          </div>{" "}
                                        </i>
                                      </p>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        {/* former */}
                        <div
                          class="tab-pane fade"
                          id="pills-profile"
                          role="tabpanel"
                          aria-labelledby="pills-profile-tab"
                        >
                          <div className="table-responsive">
                            <table
                              width="100%"
                              cellspacing="0"
                              cellpadding="0"
                              class="checklist-table table850 remove-space inventory_table"
                            >
                              <thead>
                                <tr>
                                  <th class="pic">&nbsp;</th>
                                  <th>Employee</th>
                                  <th>Status</th>
                                  <th>Function</th>
                                  <th>Employing Account</th>
                                  <th>Contact Number</th>
                                  <th>Email</th>
                                  <th>Role Title</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="avtar_pic">
                                    <figure>
                                      <img
                                        src="/img/../employee_images/1642043133.png"
                                        id="preview"
                                        alt=""
                                      />{" "}
                                    </figure>
                                  </td>
                                  <td>
                                    <b>Cynthia</b> <br />
                                    Server
                                  </td>
                                  <td>
                                    <span class="green_tag">
                                      {" "}
                                      Involuntary Ex-Staff{" "}
                                    </span>
                                  </td>
                                  <td>Service</td>
                                  <td>Boat Quay Pilot</td>
                                  <td>45645645</td>
                                  <td>cynthiajohnson@yopmail.com</td>
                                  <td>Server</td>
                                  <td>
                                    <a
                                      href="/labor_settings/viewEmployee/dGVtQUwyMHdaSnpOd1pvcmtZZ3B4Zz09"
                                      class="circle_icon"
                                    >
                                      <i class="iconSprites eye-icon">
                                        {" "}
                                        <div class="tooltip-sm">
                                          {" "}
                                          View{" "}
                                        </div>{" "}
                                      </i>
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {formOpen === true && (
          <AddEmployee
            formOpen={formOpen}
            setFormOpen={setFormOpen}
            formType={formType}
            setFormType={setFormType}
          />
        )}
      </div>
    </UserInterface>
  );
};
export default EmployeeList;
